export const BODY_TITLE_MAP = {
    man: 'Биография и факты',
    school: 'О школе',
};
